// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageSlider_root__YBA5A","slide":"ImageSlider_slide__1JEL5","slider":"ImageSlider_slider__3TH45"};